export const InvoiceStatusType = {
    NOT_ISSUED: "NotIssued",
    ISSUED: "Issued",
    REPLACED: "Replaced",
    CANCELLED: "Cancelled"
}